import React from "react";
import { ShieldAlert, ArrowUp, Minus, ArrowDown, CircleAlert, TriangleAlert, Info, CircleCheck } from "lucide-react";

// Accessibility §4A: severity is NEVER color-only — always icon + text label + color.
const MAP = {
  Critical: { cls: "bg-red-100 text-red-800 border-red-300", Icon: CircleAlert },
  High: { cls: "bg-orange-100 text-orange-800 border-orange-300", Icon: TriangleAlert },
  Medium: { cls: "bg-amber-100 text-amber-800 border-amber-300", Icon: ShieldAlert },
  Low: { cls: "bg-emerald-100 text-emerald-800 border-emerald-300", Icon: Info },
};

export function SeverityBadge({ level }) {
  const cfg = MAP[level] || { cls: "bg-slate-100 text-slate-700 border-slate-300", Icon: Info };
  const { Icon } = cfg;
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold border ${cfg.cls}`}>
      <Icon className="w-3.5 h-3.5" aria-hidden="true" />
      <span>{level}</span>
    </span>
  );
}

export function StatusBadge({ status }) {
  const good = ["Compliant", "Approved", "Done", "Closed", "Active", "Healthy", "Optimal", "Connected", "Resolved", "Ready", "Realized", "On Track", "Within", "Deployed"];
  const warn = ["Partial", "In Review", "In Progress", "Pending", "Triaging", "Degraded", "Congested", "Warning", "At Risk", "Piloting", "Projected", "Investigating", "Draft", "Planning", "On Hold", "Paused"];
  const bad = ["Non-Compliant", "Blocked", "Down", "Offline", "Error", "Breach", "Behind", "Rejected", "Gap", "Disconnected", "Open", "New"];
  let cls = "bg-slate-100 text-slate-700 border-slate-200";
  let dot = "bg-slate-400";
  if (good.includes(status)) { cls = "bg-emerald-100 text-emerald-800 border-emerald-200"; dot = "bg-emerald-500"; }
  else if (warn.includes(status)) { cls = "bg-amber-100 text-amber-800 border-amber-200"; dot = "bg-amber-500"; }
  else if (bad.includes(status)) { cls = "bg-red-100 text-red-800 border-red-200"; dot = "bg-red-500"; }
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium border ${cls}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${dot}`} aria-hidden="true" />
      {status}
    </span>
  );
}

export function TrendIcon({ trend }) {
  if (trend === "up") return <ArrowUp className="w-4 h-4 text-emerald-600" aria-label="trending up" />;
  if (trend === "down") return <ArrowDown className="w-4 h-4 text-red-600" aria-label="trending down" />;
  return <Minus className="w-4 h-4 text-slate-400" aria-label="stable" />;
}
